import { Stack, Avatar, Typography, Button } from "@mui/material";
import { NewDialogActions, NewDialogContent } from "components";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";

export default function FinalStep({ refetch, handleClose }) {
  const onClose = () => {
    refetch();
    handleClose();
  }
  return (
    <>
      <NewDialogContent isPopup>
        <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper">
          <Stack
            rowGap={3}
            flexGrow={1}
            justifyContent="center"
            alignItems="center"
          >
            <Avatar
              sx={{
                width: 120,
                height: 120,
                fontSize: 60,
                bgcolor: "success.lighter",
              }}
            >
              <CheckCircleOutlineRoundedIcon
                fontSize="inherit"
                color="success"
              />
            </Avatar>
            <Typography variant="subtitle1" color="success.main">
              با موفقیت انجام شد
            </Typography>
          </Stack>
        </Stack>
      </NewDialogContent>
      <NewDialogActions>
        <Stack
          width="100%"
          alignItems="center"
          direction="row-reverse"
          justifyContent="space-between"
        >
          <Button
            autoFocus
            size="medium"
            color="primary"
            variant="contained"
            onClick={onClose}
            sx={{ minWidth: 120 }}
          >
            بستن
          </Button>
        </Stack>
      </NewDialogActions>
    </>
  );
}
